/**
 * Swagger Lucor
 * Swagger Lucor
 *
 * OpenAPI spec version: 1.2.18
 * Contact: roger.cazangi@hotmail.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ResultadoPesquisaLogsAuditoria } from '../model/resultadoPesquisaLogsAuditoria';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';

import { environment } from '../../environments/environment';


@Injectable()
export class AuditoriaApiService {

    protected basePath = environment.apiBasePath;
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Pesquisar Logs de Auditoria
     * 
     * @param desde 
     * @param ate 
     * @param pessoaJuridicaId 
     * @param emailUsuario 
     * @param paginaAtual 
     * @param itensPorPagina 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1AuditoriaGet(desde?: Date, ate?: Date, pessoaJuridicaId?: string, emailUsuario?: string, paginaAtual?: number, itensPorPagina?: number, observe?: 'body', reportProgress?: boolean): Observable<ResultadoPesquisaLogsAuditoria>;
    public v1AuditoriaGet(desde?: Date, ate?: Date, pessoaJuridicaId?: string, emailUsuario?: string, paginaAtual?: number, itensPorPagina?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResultadoPesquisaLogsAuditoria>>;
    public v1AuditoriaGet(desde?: Date, ate?: Date, pessoaJuridicaId?: string, emailUsuario?: string, paginaAtual?: number, itensPorPagina?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResultadoPesquisaLogsAuditoria>>;
    public v1AuditoriaGet(desde?: Date, ate?: Date, pessoaJuridicaId?: string, emailUsuario?: string, paginaAtual?: number, itensPorPagina?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (desde !== undefined && desde !== null) {
            queryParameters = queryParameters.set('desde', <any>desde.toISOString());
        }
        if (ate !== undefined && ate !== null) {
            queryParameters = queryParameters.set('ate', <any>ate.toISOString());
        }
        if (pessoaJuridicaId !== undefined && pessoaJuridicaId !== null) {
            queryParameters = queryParameters.set('pessoaJuridicaId', <any>pessoaJuridicaId);
        }
        if (emailUsuario !== undefined && emailUsuario !== null) {
            queryParameters = queryParameters.set('emailUsuario', <any>emailUsuario);
        }
        if (paginaAtual !== undefined && paginaAtual !== null) {
            queryParameters = queryParameters.set('paginaAtual', <any>paginaAtual);
        }
        if (itensPorPagina !== undefined && itensPorPagina !== null) {
            queryParameters = queryParameters.set('itensPorPagina', <any>itensPorPagina);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        // return this.httpClient.request<Array<ResultadoPesquisaLogsAuditoria>>('get',`${this.basePath}/v1/auditoria`,
        return this.httpClient.request<ResultadoPesquisaLogsAuditoria>('get',`${this.basePath}/v1/auditoria`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
